import {
  reqDriverLocations,
  reqDriverOptions,
  reqAddress,
} from '@/api/driverMonitor'
import axios from 'axios'
import { Notification } from 'element-ui'

export default {
  async fetchDriverLocations({ commit }) {
    try {
      const { result } = await reqDriverLocations()
      commit('setDriverLocations', result)
    } catch (e) {
      console.error(e)
    }
  },
  async fetchDriverOptions({ commit }) {
    commit('setDriverOptionsLoading', true)
    try {
      const { driverList } = await reqDriverOptions()

      if (!driverList) {
        return
      }

      if (!Array.isArray(driverList)) {
        console.error('driverList 不是陣列:', typeof driverList)
        return
      }

      const driverOptions = driverList.sort((a, b) => {
        return a.call_number - b.call_number
      })

      commit('setDriverOptions', driverOptions)
      commit('setDriverOptionsLoading', false)
    } catch (e) {
      console.error('fetchDriverOptions 發生錯誤:', e)
      commit('setDriverOptionsLoading', false)
    }
  },
  async fetchDriverTabAddr({ state, commit }) {
    if (state.driverInfo.lng && state.driverInfo.lat) {
      try {
        const CancelToken = axios.CancelToken
        const source = CancelToken.source()
        if (state.cancelAddrRequest) {
          state.cancelAddrRequest.cancel(
            'GET web/api/service/address/near請求取消',
          )
        }
        commit('setCancelAddrRequest', source)
        commit('setIsTabLoading', true)
        const { result } = await reqAddress(
          state.driverInfo.lng,
          state.driverInfo.lat,
          { cancelToken: source.token },
        )
        commit('setDriverTabAddr', result[0])
        commit('setCancelAddrRequest', null)
        commit('setIsTabLoading', false)
      } catch (thrown) {
        if (thrown.isCancel) {
          console.warn('上一個尋找司機地址的api請求已經取消')
        }
        commit('setIsTabLoading', false)
        Notification({
          title: '搜尋地址發生錯誤，請稍後再試',
          type: 'error',
        })
        console.error(thrown)
      }
    } else {
      Notification({
        title: '缺少經緯度資訊，無法取得地址',
        type: 'warning',
      })
    }
  },
}



// WEBPACK FOOTER //
// ./src/store/driverMonitor/actions.js